/* Patkay prefetch triggers/timing; explicit safe document destinations only. */
(function () {
  'use strict';
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  var prefetched = new Set();
  var hoverTimer;
  function target(el) {
    var a = el && el.closest ? el.closest('a[href]') : null;
    if (!a || a.hasAttribute('download') || a.target === '_blank' || a.relList.contains('nofollow')) return null;
    if (a.closest('form[action*="localization"], [data-localization-form], .nav-lang, [data-locale], [data-currency]')) return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (!/^https?:$/.test(u.protocol) || u.origin !== location.origin || u.pathname === location.pathname) return null;
    var path;
    try { path = decodeURIComponent(u.pathname).toLowerCase().replace(/\/+/g, '/'); } catch (e) { return null; }
    /* Segment matching also excludes locale-prefixed /de/cart etc. */
    if (/(?:^|\/)(?:cart|account|checkout|checkouts|logout|localization|localisation)(?:\/|$|[.;])/.test(path)) return null;
    if (/(?:^|\/)(?:currency|currencies|locale|locales|language|languages)(?:\/|$)/.test(path)) return null;
    if (/\/discount(?:\/|$)/.test(path) || u.searchParams.has('return_to')) return null;
    var unsafe = false;
    u.searchParams.forEach(function (value, key) {
      if (/(?:^|_)(?:currency|country|locale|language|logout|checkout|cart)(?:$|_)/i.test(key)) unsafe = true;
    });
    return unsafe ? null : u.href;
  }
  function warm(href) {
    if (prefetched.has(href)) return;
    prefetched.add(href);
    var link = document.createElement('link');
    link.rel = 'prefetch'; link.as = 'document'; link.href = href;
    document.head.appendChild(link);
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var href = target(e.target);
    if (href) { clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { warm(href); }, 60); }
  }, { capture: true, passive: true });
  document.addEventListener('pointerout', function () { clearTimeout(hoverTimer); }, { capture: true, passive: true });
  document.addEventListener('touchstart', function (e) { var href = target(e.target); if (href) warm(href); }, { capture: true, passive: true });
  document.addEventListener('focusin', function (e) { var href = target(e.target); if (href) warm(href); }, { capture: true, passive: true });
})();
